import { render, staticRenderFns } from "./PainterMsgSuperDetails.vue?vue&type=template&id=52e94e41&scoped=true"
import script from "./PainterMsgSuperDetails.vue?vue&type=script&lang=js"
export * from "./PainterMsgSuperDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterMsgSuperDetails.vue?vue&type=style&index=0&id=52e94e41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e94e41",
  null
  
)

export default component.exports